//
//
//
//
//
//
//
//
//
//
//
//
//
import newUserPaid from "./userPaymentPpenetrationRate/newUserPaid";
import levelPaymentAmount from "./userPaymentPpenetrationRate/levelPaymentAmount";
import levelPaymentFrequency from "./userPaymentPpenetrationRate/levelPaymentFrequency";
export default {
  name: "userPaymentPpenetrationRate",
  components: {
    newUserPaid: newUserPaid,
    levelPaymentAmount: levelPaymentAmount,
    levelPaymentFrequency: levelPaymentFrequency
  },
  mixins: [],
  data: function data() {
    return {
      activeIndex: 'newUserPaid'
    };
  },
  created: function created() {},
  activated: function activated() {},
  methods: {
    handover: function handover(index) {
      this.activeIndex = index;
    }
  }
};